import React, { useEffect } from 'react';
import { onMockNotification } from '../api';
import { useToast } from '../contexts/ToastContext';

// 通知（LINE／メール）の送信結果をトーストとして表示する。
const NotificationToaster: React.FC = () => {
  const { showToast } = useToast();
  useEffect(() => {
    return onMockNotification((n) => {
      showToast(`【${n.channel}】${n.title}${n.detail ? `${n.detail}。` : ''}`, 'info');
    });
  }, [showToast]);
  return null;
};

export default NotificationToaster;
